<template>
  <div class="battery-icon">
    <img :src="src" width="25px" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    surplus: {
      type: Number,
      default: 0
    }
  },
  computed: {
    src() {
      const img = this.getSrc(this.surplus);
      return require(`@/assets/image/battery/${img}`);
    }
  },
  methods: {
    getSrc(capacity) {
      const configs = [
        { min: 80, img: '4.png' },
        { min: 60, img: '3.png' },
        { min: 40, img: '2.png' },
        { min: 20, img: '1.png' },
        { min: 0, img: '0.png' }
      ];
      return configs.find(e => capacity >= e.min).img;
    }
  }
};
</script>

<style lang="scss">
.battery-icon {
  display: inline-block;
  vertical-align: baseline;
}
</style>
